import { CaseReviewEnum, isDisplayableCaseReview } from '@/citator/schema/case-review-schema'
import { kCaseReviewDefinitions } from '@/citator/utils/case-review-definitions'
import { ReviewDot } from '@/citator/components/ReviewDot'
import clsx from 'clsx'

type CaseReviewTagProps = {
  /** Citator review enum value. */
  review: CaseReviewEnum
  className?: string
}

/** Citing-case review badge. Uses a neutral pill plus severity dot per design. */
export function CaseReviewTag({ review, className }: CaseReviewTagProps) {
  if (!isDisplayableCaseReview(review)) return null
  const info = kCaseReviewDefinitions[review]
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 pl-2 pr-2.5 py-0.5 bg-white ring-1 ring-inset ring-brand-neutral-200 rounded-full text-sm font-medium leading-5 text-brand-neutral-600 whitespace-nowrap',
        className
      )}
    >
      <ReviewDot color={info.dotColor} />
      {info.label}
    </span>
  )
}
